import { useState } from "react";
import Card from "react-bootstrap/Card";
import Header from "./Header";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import TuneIcon from "@mui/icons-material/Tune";
import Button from "react-bootstrap/esm/Button";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

export default function Vendor() {
  const data = [
    {
      name: "Rahul",
      Date: "06-28-2023",
      mobile: 2384759234,
      AssignedJob: 34,
      CompletedJob: 26,
      img: "https://lawschoolpolicyreview.files.wordpress.com/2018/06/passport-size-photo-2-e1558013566564.jpg",
    },

    {
      name: "Sohel",
      Date: "06-30-2023",
      mobile: 2384759234,
      AssignedJob: 34,
      CompletedJob: 26,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR34R0O05LegURUY4r7XpTJdl-LL6aM2oqFiT2ftXDI1IGF5v7-fseCri-eJ6hJqD-N2G0&usqp=CAU",
    },
    {
      name: "Ramesh",
      Date: "12-05-2023",
      mobile: 2384759234,
      AssignedJob: 34,
      CompletedJob: 26,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTSLk-zOT6LhOK5DfCt-_-khEFvCeZ1voYF-Q&usqp=CAU",
    },

    {
      name: "Ashwin",
      Date: "10-06-2023",
      mobile: 2384759234,
      AssignedJob: 34,
      CompletedJob: 26,
      img: "data:image/jpeg;base64,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",
    },
    {
      name: "Rahul",
      Date: "06-28-2023",
      mobile: 2384759234,
      AssignedJob: 34,
      CompletedJob: 26,
      img: "https://lawschoolpolicyreview.files.wordpress.com/2018/06/passport-size-photo-2-e1558013566564.jpg",
    },
    {
      name: "Deepti",
      Date: "06-05-2023",
      mobile: 2384759234,
      AssignedJob: 34,
      CompletedJob: 26,
      img: "data:image/jpeg;base64,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",
    },
    {
      name: "Rahul",
      Date: "06-28-2023",
      mobile: 2384759234,
      AssignedJob: 34,
      CompletedJob: 26,
      img: "https://lawschoolpolicyreview.files.wordpress.com/2018/06/passport-size-photo-2-e1558013566564.jpg",
    },
    {
      name: "Karthik",
      Date: "12-04-2023",
      mobile: 2384759234,
      AssignedJob: 34,
      CompletedJob: 26,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQPCCZ2q7hO7heIdMczNJC8h0-DPXudlGE8lA&usqp=CAU",
    },
  ];
  const [addVendor, setAddVendor] = useState(false);
  const [filter, setFilter] = useState(false);
  const [edit, setEdit] = useState(false);
  const [selected, setSelected] = useState(null);
  const [addBank, setAddBank] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const handleAddBank = () => {
    setAddBank(true);
  };
  const handlebankSave = () => {
    setAddBank(false);
  };
  const handlesetSelected = (index) => {
    setSelected(index);
  };
  const handleEdit = () => {
    setEdit(!edit);
  };
  const handleFilter = () => {
    setFilter(!filter);
  };

  const handleAddVendor = () => {
    setAddVendor(true);
  };
  const handleSaveVendor = () => {
    setAddVendor(false);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const handleFileUpload = () => {
    if (selectedFile) {
      console.log("Uploading file:", selectedFile.name);

      // Call the uploadImageFile function with the selected file
      uploadImageFile(selectedFile);
    } else {
      console.log("No file selected");
    }
  };

  const uploadImageFile = (file) => {
    const formData = new FormData();
    formData.append("image", file);

    // logic for file upload in react ?
    fetch("/api/upload/image", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        if (response.ok) {
          console.log("Image file uploaded successfully");
          // Handle success case
        } else {
          console.log("Failed to upload image file");
          // Handle failure case
        }
      })
      .catch((error) => {
        console.log("Error occurred during image file upload:", error);
        // Handle error case
      });
  };

  return (
    <>
      <Header />

      <div className="row m-auto  containerPadding">
        {" "}
        {!selected ? (
          <div className="col-md-12 ">
            {!addVendor ? (
              <>
                <div className="row m-auto">
                  <div className="col-md-12">
                    <div className="row ">
                      <div className="col-md-12 text-end m-auto">
                        <div className="row ">
                          <div>
                            {" "}
                            <TuneIcon onClick={handleFilter} />
                          </div>
                          <Button
                            className="col-md-2 "
                            style={{ border: "1px solid green" }}
                            onClick={handleAddVendor}
                          >
                            Add Vendor
                          </Button>{" "}
                        </div>
                      </div>
                    </div>{" "}
                  </div>
                </div>

                <div className="col-md-12 float-end m-auto">
                  <div
                    className={!filter ? "col-md-2 hide" : "col-md-2 "}
                    style={{
                      position: "absolute",
                      top: "20%",
                      right: "1.8%",
                      zIndex: "100",
                      backgroundColor: "white",
                      boxShadow: "2px 2px 2px white",
                    }}
                  >
                    <p>Sort By</p>
                    <p>Date(new to old)</p>
                    <p>Date (old to new)</p>
                  </div>{" "}
                </div>

                <div className="row ">
                  {data.map((ele, index) => {
                    return (
                      <Card
                        className="col-md-4 m-3 "
                        style={{
                          width: "200px",
                          height: "250px",
                          borderRadius: "10%",
                        }}
                      >
                        <div
                          className="row text-center m-auto"
                          onClick={() => handlesetSelected(index)}
                        >
                          <img
                            style={{
                              width: "70%",
                              height: "50%",
                              borderRadius: "100%",
                            }}
                            className="m-auto"
                            src={ele.img}
                            alt=""
                          />

                          <span>{ele.name}</span>
                          <span>{ele.mobile}</span>
                          <span style={{ color: "orange" }}>
                            Jobs Assigned
                            <span style={{ margin: "5px" }}>
                              {ele.AssignedJob}
                            </span>
                          </span>
                          <span style={{ color: "green" }}>
                            Jobs Completed
                            <span style={{ margin: "5px" }}>
                              {ele.CompletedJob}
                            </span>
                          </span>
                        </div>
                      </Card>
                    );
                  })}
                </div>
              </>
            ) : (
              <>
                {!addBank ? (
                  <Form>
                    <>
                      <Row className="mb-3">
                        <Col className="mb-3">
                          <Form.Label>Vendor First Name</Form.Label>
                          <Form.Control placeholder="First name" />
                        </Col>
                        <Col className="mb-3">
                          <Form.Label>Vendor Last Name</Form.Label>
                          <Form.Control placeholder="Last name" />
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <Col className="mb-3">
                          <Form.Label>Vendor Phone Number</Form.Label>
                          <Form.Control placeholder="Please Enter  Contact number" />
                        </Col>
                        <Col className="mb-3">
                          <Form.Label>Vendor Email </Form.Label>
                          <Form.Control placeholder="Please Enter Your Email" />
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <Col className="mb-3" onClick={handleAddBank}>
                          <span
                            style={{ fontSize: "20px", marginRight: "5px" }}
                          >
                            Add Bank
                          </span>
                          <span>
                            <i
                              style={{ fontSize: "20px" }}
                              class="fa-solid fa-circle-plus "
                            ></i>
                          </span>
                        </Col>{" "}
                      </Row>
                      <Row className="mb-3">
                        <Col className="mb-3">
                          <Form.Label>Vendor Address</Form.Label>
                          <Form.Control
                            as="textarea"
                            placeholder="Please Enter  Address"
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3 text-center">
                        <Col className="mb-3">
                          <Button onClick={handleSaveVendor}>
                            Save Vendor
                          </Button>
                        </Col>
                      </Row>
                    </>
                  </Form>
                ) : (
                  <>
                    <Form>
                      <>
                        <Row className="mb-3">
                          <Col className="mb-3">
                            <Form.Label>Select Bank</Form.Label>
                            <Form.Select>
                              <option>Choose...</option>
                              <option>State Bank of India</option>
                              <option>State Bank of India</option>
                              <option>State Bank of India</option>
                              <option>State Bank of India</option>
                              <option>State Bank of India</option>
                            </Form.Select>
                          </Col>
                          <Col className="mb-3">
                            <Form.Label>Account Name</Form.Label>
                            <Form.Control placeholder="Enter your account name" />
                          </Col>{" "}
                          <Col className="mb-3">
                            <Form.Label>A/C Number</Form.Label>
                            <Form.Control placeholder="Please enter  account number" />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col className="mb-3">
                            <Form.Label>Branch</Form.Label>
                            <Form.Control placeholder="Please enter branch" />
                          </Col>
                          <Col className="mb-3">
                            <Form.Label>A/C Type </Form.Label>
                            <Form.Control placeholder="Please enter account type" />
                          </Col>
                          <Col className="mb-3">
                            <Form.Label>IFSC Code </Form.Label>
                            <Form.Control />
                          </Col>
                        </Row>
                        <Row className="mb-3 text-center">
                          <Col>OR</Col>
                        </Row>
                        <Row className="mb-3 upload">
                          <Col className="mb-3">
                            <Form.Label>
                              <CloudUploadIcon
                                style={{ fontSize: "50px" }}
                                className="cloud-icon "
                              />
                              <Form.Control
                                id="excel-file-input"
                                accept=".xlsx, .xls,image"
                                onChange={handleFileChange}
                                style={{ display: "none" }}
                                type="file"
                              />
                            </Form.Label>
                          </Col>
                          <Row className="m-auto">
                            <h5
                              onClick={handleFileUpload}
                              className="col-md-3 submit-button m-auto"
                            >
                              Upload File
                            </h5>
                          </Row>
                          <Row className="m-auto">
                            {" "}
                            <p
                              onClick={handleFileUpload}
                              className="col-md-3 submit-button m-auto"
                            >
                              Drag and drop files here
                            </p>
                          </Row>
                        </Row>

                        <Row className="mb-3 text-center">
                          <Col className="mb-3">
                            <Button onClick={handleSaveVendor}>Add</Button>
                          </Col>
                        </Row>
                      </>
                    </Form>
                  </>
                )}
              </>
            )}
          </div>
        ) : (
          <div className="row  m-auto">
            {selected !== null && (
              <>
                <div className="row m-auto">
                  <div className="col-md-12 ">
                    <div className="col-md-5 m-auto">
                      <p>
                        <img
                          variant="top"
                          src={data[selected].img}
                          alt=""
                          style={{
                            width: "100px",
                            height: "100px",
                            borderRadius: "100%",
                          }}
                        />
                      </p>
                      <p>
                        <span className="cl">Name:</span>
                        <span> {data[selected].name}</span>
                      </p>
                      <p>
                        <span className="cl">Contact Number:</span>
                        <span> {data[selected].mobile}</span>
                      </p>
                      <p>
                        <span className="cl">Email:</span>
                        <span> {data[selected].name}234@gmail.com</span>
                      </p>
                      <p>
                        <span className="cl">Account Number:</span>
                        <span> 21{data[selected].mobile}32</span>
                      </p>
                      <p>
                        <span className="cl">Address:</span>
                        <span>
                          #374, Dwaraka Nagar, Channasandra Near Yuva Hardware
                        </span>
                      </p>
                      <div className="row ">
                        {edit ? (
                          <Button
                            className="col-md-3 m-2"
                            onClick={() => setSelected(null)}
                          >
                            Save
                          </Button>
                        ) : (
                          <Button className="col-md-3 m-2" onClick={handleEdit}>
                            Edit
                          </Button>
                        )}
                        <Button className="col-md-3 m-2">Delete</Button>{" "}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
}
